import React from 'react';
export function createContext(providerName) {
  var hookNameOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "use".concat(providerName, "Context");
  var providerNameOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "".concat(providerName, "Provider");
  var Context = /*#__PURE__*/React.createContext(undefined);

  var useContext = () => {
    var contextValue = React.useContext(Context);

    if (contextValue === undefined) {
      throw new Error("".concat(hookNameOverride, " must be used inside of a ").concat(providerNameOverride, "."));
    }

    return contextValue;
  };

  return [useContext, Context];
}